<template>
  <v-container>
    <v-progress-linear v-show="this.$apollo.queries.getAllPackages.loading"></v-progress-linear>
    <v-row class="px-0 mt-n4 mt-sm-0">
      <v-col v-for="packages in packagesList" :key="packages.id" cols="12" sm="4" lg="3">
        <v-card max-width="300" elevation="3" class="pt-3 mx-auto mt-2 mt-sm-0">
          <v-img class="mx-3 light--text align-end" height="150px" :src="imageUrl + packages.image"></v-img>
          <v-layout justify-center class="mt-4 dark--text font-weight-medium text-body-1">
            {{ packages.titleEn }}
          </v-layout>

          <v-card-actions>
            <v-row>
              <v-col sm="6" md="12" class="flex ">
                <v-row justify="center">
                  <v-icon v-show="packages.active" color="primary">mdi-checkbox-marked</v-icon>
                  <v-icon v-show="!packages.active" color="grey">mdi-checkbox-blank-outline</v-icon>
                </v-row>
              </v-col>
              <v-col sm="6" md="4">
                <PackageDuplicateForm v-if="hasRole(AdminUserPermissions.PLAN_DUPLICATE)" :package_id="packages._id" />
              </v-col>
              <v-col sm="6" md="3">
                <v-btn small class="mx-2 my-1 light--text text-capitalize" tile color="#92E84E" @click="showUpdate(packages._id)">Edit</v-btn>
              </v-col>
              <v-col sm="6" md="4" class="ps-sm-0 ps-md-3">
                <PackageDelete v-if="hasRole(AdminUserPermissions.PLAN_DELETE)" :package_id="packages._id" />
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import PackageUpdateForm from "../components/PackageUpdateForm.vue";
import PackageDuplicateForm from "../components/PackageDuplicateForm.vue";
import PackageDelete from "../components/PackageDelete.vue";
export default {
  components: {
    // PackageUpdateForm,
    PackageDelete,
    PackageDuplicateForm,
  },
  data: () => ({
    imageUrl: process.env.VUE_APP_BASE_URL,
    dialog: false,
    packagesList: [],
  }),
  mounted() {
    this.$root.$on("updatePackage", () => {
      this.loading = true;
      this.$apollo.queries.getAllPackages.refetch({});
    });
  },
  apollo: {
    getAllPackages() {
      return {
        query: require("../api/getAllPackages.graphql"),
        result({ data }) {
          this.packagesList = data.getAllPackages.packages;
        },
      };
    },
  },
  methods: {
    showUpdate(id) {
      this.$router.push({
        name: "UpdatePackage",
        query: { id: id },
      });
    },
  },
};
</script>
